// TODO rootファイルを呼び出したいので、index.tsxという命名にしたい
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import {
  StylesProvider,
  ThemeProvider as MuiThemeProvider,
} from '@material-ui/core/styles';
// TODO 必要かどうか精査した上で、削除かリファクタリングする
import AppSnackbarProvider from '../core/Snackbar/AppSnackbarProvider';
import { theme } from './styles/index';
import NewThemeProvider from './styles/ThemeProvider';
// TODO 必要かどうか精査した上で、削除かリファクタリングする
import jss from '../core/styles/jss';
import { configureAppStore } from './store/configureStore';
import Router from './pages';
import './translations/config';

const store = configureAppStore();

const App = () => (
  <Provider store={store}>
    <MuiThemeProvider theme={theme}>
      <ThemeProvider theme={theme}>
        <StylesProvider jss={jss}>
          <AppSnackbarProvider maxSnack={3}>
            <NewThemeProvider>
              <Router />
            </NewThemeProvider>
          </AppSnackbarProvider>
        </StylesProvider>
      </ThemeProvider>
    </MuiThemeProvider>
  </Provider>
);

document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('root');

  if (root) {
    if (process.env.NODE_ENV === 'development') {
      ReactDOM.render(
        <React.StrictMode>
          <App />
        </React.StrictMode>,
        root,
      );
    } else {
      ReactDOM.render(<App />, root);
    }
  }
});
